export class FormularioDespacho{
    public consecutivo: string; // REQCSC TABLA SERVICIOS
    public radicado: string; //  grugru tabla grupos_afi
    public nombreRadicado: string; // grunom tabla grupos_afi
    public nombre_titular: string; // titnom titulares afi
    public nombre_paciente: string; // campos del nombre en beneficiarios o si es tipo de contrato (grutpc = 0 | 4 | 5 | 6 | 7) se toma del campo bennom en beneficiarios_ap
    public ID_Grupo: number;
    public ID_Titular: number;
    public id_ben_ap: number;
    public direccion: string; // campo  beneficiario
    public tel: string; // bentel beneficiario
    public edad: string; // edad del beneficiario
    public sexo: string; // Sexo del beneficiario bensex
    public cel: string; // Celular del beneficiario bencel
    public documento_paciente: string; // Documento del paciente bendoc o bendocap
    public tel_llamada: string; // telefono desde donde realizan la llamada reqtel
    public nombre_llamada: string; // nombre de la persona que llama reqper
    public direccion_llamada: string; // dirección a donde se irá REQDIR
    public eps: number; // EPS Del paciente beneps
    public signos_sintomas: string; // signos y sintomas del paciente
    public id_evaluacion: string;
    public t_Consultas: string;
    public meses: number;
    public rellamadas: number;
    public numeroReingresos: number;
    public revaloracion: string;
    public reqcda: string;
    public bening: string;
    public reqtps: string;
    public reqfpg: string;
    public cansrv: string;
    public reqnov: string;
    public bentxt: string;
    public infase: string;
    public reqtxo: string;
    public benrdo: string;
    public reqcda2: string;
    public csctraslado: string;
    public reqhdp: string;
    public HConsCSC: string;
    public HCreaHC: string;
    public HMotAnte: string;
    public HExaFis: string;
    public Htratamiento: string;
    public HFirma: string;
    public HCodiValo: string;
    public reqhll: string;
    public celNotificacion: string;
    public bencba: number;
    public tpc: number;
    public coordenadas:string;
    public dirvalidada:string;
    public dircompleta:string;
    public prioridadPorSintoma:number;
    public ap:boolean;
    public matricula:string;
    public sms:Object;
    public parqueadero:number;
    public parqueadero_servicios:number;
    public Ape:number;

    constructor(){
        this.consecutivo = null;
        this.radicado = null;
        this.nombreRadicado = null;
        this.nombre_titular = null;
        this.nombre_paciente = null;
        this.ID_Grupo = null;
        this.ID_Titular = null;
        this.id_ben_ap = null;
        this.direccion = null;
        this.tel = null;
        this.edad = null;
        this.sexo = null;
        this.cel = null;
        this.documento_paciente = null;
        this.tel_llamada = null;
        this.nombre_llamada = null;
        this.direccion_llamada = null;
        this.eps = null;
        this.signos_sintomas = null;
        this.id_evaluacion = null;
        this.t_Consultas = null;
        this.meses = null;
        this.rellamadas = null;
        this.numeroReingresos = null;
        this.revaloracion = null;
        this.reqcda = null;
        this.bening = null;
        this.reqtps = null;
        this.reqfpg = null;
        this.cansrv = null;
        this.reqnov = null;
        this.bentxt = null;
        this.infase = null;
        this.reqtxo = null;
        this.benrdo = null;
        this.reqcda2 = null;
        this.csctraslado = null;
        this.reqhdp = null;
        this.HConsCSC = null;
        this.HCreaHC = null;
        this.HMotAnte = null;
        this.HExaFis = null;
        this.Htratamiento = null;
        this.HFirma = null;
        this.HCodiValo = null;
        this.reqhll = null;
        this.celNotificacion = null;
        this.bencba = null;
        this.tpc = null;
        this.coordenadas = null;
        this.dirvalidada = null;
        this.dircompleta = null;
        this.prioridadPorSintoma = null;
        this.ap = null;
        this.matricula = null;
        this.sms = null;
        this.parqueadero = null;
        this.parqueadero_servicios = null;
        this.Ape = null;
    }
}
